import supabase from "../../../shared/database/supabase";
import { ServiceOrderLineRepository } from "../../../models/service-order-line/service-order-line.repository";

export interface UpdateServiceOrderLineParams {
    serviceOrderLineId: string;
    cost?: number;
    workHours?: number;
    costByWorkHour?: number;
    discount?: number;
    description?: string;
    finished?: boolean;
    finishedBy?: string | null;
    controlled?: boolean;
}

export const updateServiceOrderLine = async (params: UpdateServiceOrderLineParams) => {
    try {
        const { data, error } = await supabase.functions.invoke<ServiceOrderLineRepository>("update-service-order-line", {
            body: JSON.stringify({
                service_order_line_id: params.serviceOrderLineId,
                cost: params.cost !== undefined ? params.cost : undefined,
                work_hours: params.workHours !== undefined ? params.workHours : undefined,
                cost_by_work_hour: params.costByWorkHour !== undefined ? params.costByWorkHour : undefined,
                discount: params.discount !== undefined ? params.discount : undefined,
                description: params.description !== undefined ? params.description : undefined,
                finished: params.finished !== undefined ? params.finished : undefined,
                finished_by: params.finishedBy !== undefined ? params.finishedBy : undefined,
                controlled: params.controlled !== undefined ? params.controlled : undefined,
            }),
        });

        if (error) {
            console.error("Error calling update-service-order-line:", error);
            return { data: null, error };
        }
        return { data: data, error: null };
    } catch (err) {
        console.error("Exception in updateServiceOrderLine:", err);
        throw err;
    }
};